//@ts-nocheck
import { store } from 'core/store/configureStore';
import { useInjectReducer as useReducer, useInjectSaga as useSaga } from 'redux-injectors';
import { createReducer } from 'core/store/reducers';
import { InjectReducerParams, InjectSagaParams, RootStateKeyType } from './types/injector-typings';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DAEMON, ONCE_TILL_UNMOUNT, RESTART_ON_REMOUNT } from 'constants/injectModes';
/* Wrap redux-injectors with stricter types */

export function useInjectReducer<Key extends RootStateKeyType>(params: InjectReducerParams<Key>) {
  return useReducer(params);
}

export function useInjectSaga(params: InjectSagaParams) {
  return useSaga(params);
}

export function injectReducer(key, reducer) {
  store.injectedReducers[key] = reducer;
  store.replaceReducer(createReducer(store.injectedReducers));
  //@ts-ignore
  store.persistor.persist();
}

export function injectSaga(key, saga) {
  store.injectedSagas[key] = {
    saga,
    mode: DAEMON,
    task: store.runSaga(saga),
  };
}
